import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row p-3" }
const _hoisted_2 = { class: "col-12 col-lg-3" }
const _hoisted_3 = { class: "col-12 col-lg-9 align-items-center center-highlight-item" }
const _hoisted_4 = { class: "text-start text-primary m-3" }
const _hoisted_5 = { class: "col-12 d-flex flex-wrap gap-3 p-1" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "card-body text-start" }
const _hoisted_8 = {
  key: 0,
  class: "badge badge-primary bg-secondary ms-1 mb-2"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { key: 3 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("nav", { "aria-label": "Page navigation example" }, null, -1)
const _hoisted_13 = { class: "d-flex justify-content-end mx-5 my-2" }
const _hoisted_14 = { "aria-label": "Page navigation example" }
const _hoisted_15 = { class: "pagination" }
const _hoisted_16 = { class: "page-item" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "page-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CategoryItem = _resolveComponent("CategoryItem")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_CategoryItem)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.store.getters.localized('allProduct')), 1),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.docs, (item, index) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            class: "col-12 text-decoration-none card border border-0",
            style: {"width":"12rem"},
            to: `/product/${item._id}`
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                class: "img-fluid p-3 rounded",
                src: _ctx.imageUrl(item.images?.[0]?.path),
                alt: "Card image cap",
                style: {"aspect-ratio":"1/1"}
              }, null, 8, _hoisted_6),
              _createElementVNode("div", _hoisted_7, [
                (index === 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, "New"))
                  : _createCommentVNode("", true),
                (_ctx.store.state.language==='th')
                  ? (_openBlock(), _createElementBlock("h5", _hoisted_9, _toDisplayString(item.nameTH), 1))
                  : (_ctx.store.state.language==='ch')
                    ? (_openBlock(), _createElementBlock("h5", _hoisted_10, _toDisplayString(item.nameCH), 1))
                    : (_openBlock(), _createElementBlock("h5", _hoisted_11, _toDisplayString(item.nameEN), 1)),
                _createElementVNode("p", null, _toDisplayString(_ctx.store.getters.localized('codeProduct')) + " : " + _toDisplayString(item.code), 1),
                _hoisted_12
              ])
            ]),
            _: 2
          }, 1032, ["to"]))
        }), 256))
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("nav", _hoisted_14, [
          _createElementVNode("ul", _hoisted_15, [
            _createElementVNode("li", _hoisted_16, [
              _createElementVNode("a", {
                class: "page-link",
                href: "#",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updatePaginate(_ctx.page-1)))
              }, "«")
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginate, (item, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, null, [
                (index>_ctx.page-_ctx.limit&&index<_ctx.page+_ctx.limit)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 0,
                      class: _normalizeClass(["page-item", {'active':(index==(_ctx.page-1))}])
                    }, [
                      _createElementVNode("a", {
                        class: "page-link",
                        href: "#",
                        onClick: ($event: any) => (_ctx.updatePaginate(index+1))
                      }, _toDisplayString(index+1), 9, _hoisted_17)
                    ], 2))
                  : _createCommentVNode("", true)
              ], 64))
            }), 256)),
            _createElementVNode("li", _hoisted_18, [
              (_ctx.page!=_ctx.pages)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "page-link",
                    href: "#",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updatePaginate(_ctx.page+1)))
                  }, " » "))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}